// global modules
import { mapActions } from "vuex"
import { VBtnAction, ModelDataTable } from "@/components/reusable_components/next"

// local modules
import OrdererService from '@/services/api/Warehouse/WhOrderer'

// local objects
import filters from "./filters"
import headers from "./headers"

/**
 * @description
 * 
 */
export default {
    name: "orderer-unprocessed",
    components: {
        VBtnAction,
        ModelDataTable,
    },
    computed: {

        /**
         * @description
         * 
         */
        tableProps () {
            return {
                service: new OrdererService().toList(),
                filters,
                headers,
                paramFilter: {
                    was_processed: false,
                },
                rowsPerPage: 25,
            }
        },
    },
    methods: {
        
        /**
         * @description
         * 
         */
        ...mapActions("MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
        }),

        /**
         * @description
         * 
         */
        detail ( event ) {
            this.$router.push({ name: "orderer-update", params: { id: event.item.id } })
        },
        
        /**
         * @description
         * 
         */
        process ( event ) {
            this.$router.push({ name: "orderer-process", params: { id: event.item.id } })
        },
    },
    watch: {

        /**
         * 
         */
        responseConfirm ( val ) {
            switch ( val ) {
                case "confirmar": return this.selected.delete().then( this.success ).then( this.$refs.table.refresh ).catch( this.error ); 
            }
        },
    },
    beforeMount () {

        // set the view title
        this.setTitleTopBar( "Solicitudes de abastecimiento sin procesar" )
    },
    beforeRouteEnter ( to, from, next ) {
        next(ctx => {
            if (!ctx.$can("VIEW_ALL_PURCHASE_QUOTATION")) ctx.$router.push("/")
        })
    },
}
